<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle">トライアル申し込み</h1>
      <p class="l-text" style="margin-bottom:20px;">必要事項を記入のうえ、送信ボタンをクリックしてください。
      <br>送信いただいた内容を確認し、診断協会より連絡しますのでお待ちください。
      <div class="l-contentsBox">
        <table class="l-form-table">
          <tr>
            <th class="v-middle"><span>社名<em class="label-required">必須</em></span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.form.$model.corpName" name="form.corpName"></TextBox>
              </div>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.form.corpName.$error" validation="required" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>担当者名<em class="label-required">必須</em></span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.form.$model.responsibleName" name="form.responsibleName"></TextBox>
              </div>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.form.responsibleName.$error" validation="required" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>部署名</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.form.$model.deptName" name="form.deptName"></TextBox>
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>メールアドレス<em class="label-required">必須</em></span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.form.$model.mailAddress" name="form.mailAddress"></TextBox>
              </div>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.form.mailAddress.$error && !$v.form.mailAddress.required" validation="required" />
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.form.mailAddress.$error && !$v.form.mailAddress.email" validation="email" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>郵便番号<em class="label-required">必須</em></span></th>
            <td class="v-middle">
              <div class="l-inputAccount w-vshort">
                <TextBox v-model="$v.form.$model.postCd" name="form.postCd"></TextBox>
              </div>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.form.postCd.$error && !$v.form.postCd.required" validation="required" />
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.form.postCd.$error && !$v.form.postCd.numeric" validation="numeric" />
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.form.postCd.$error && !$v.form.postCd.maxLength" validation="maxLength" valueLength="7" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>都道府県<em class="label-required">必須</em></span></th>
            <td class="v-middle">
              <div class="l-select w-auto">
                <SelectBox v-model="$v.form.$model.prefectureCd"
                  name="form.prefectureCd"
                  :options="prefs"
                  :selectedValue="this.form.prefectureCd"></SelectBox>
              </div>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.form.prefectureCd.$error" validation="required" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>市区町村・番地<em class="label-required">必須</em></span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.form.$model.address2" name="inputForm.address2"></TextBox>
              </div>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.form.address2.$error && !$v.form.address2.required" validation="required" />
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.form.address2.$error && !$v.form.address2.maxLength" validation="maxLength" valueLength="20" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>建物名・部屋番号など</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.form.$model.address3" name="inputForm.address3"></TextBox>
              </div>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.form.address3.$error && !$v.form.address3.maxLength" validation="maxLength" valueLength="300" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>電話番号<em class="label-required">必須</em></span></th>
            <td class="v-middle">
              <div class="l-inputAccount w-short">
                <TextBox v-model="$v.form.$model.tel" name="form.tel" style="width: 300px;" placeholder="例: 000-0000-0000"></TextBox>
              </div>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.form.tel.$error" validation="required" />
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.form.tel.$error && !$v.form.tel.maxLength" validation="maxLength" valueLength="13" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>電話番号(ご担当者様)</span></th>
            <td class="v-middle">
              <div class="l-inputAccount w-short">
                <TextBox v-model="$v.form.$model.responsibleTel" name="form.tel" style="width: 300px;" placeholder="例: 000-0000-0000"></TextBox>
              </div>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.form.responsibleTel.$error && !$v.form.responsibleTel.maxLength" validation="maxLength" valueLength="13" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>FAX番号</span></th>
            <td class="v-middle">
              <div class="l-inputAccount w-short">
                <TextBox v-model="$v.form.$model.faxNo" name="form.faxNo" style="width: 300px;" placeholder="例: 000-0000-0000"></TextBox>
              </div>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.form.faxNo.$error && !$v.form.faxNo.maxLength" validation="maxLength" valueLength="13" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>ご紹介者様</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.form.$model.introducerHonorificsName" name="form.introducerHonorificsName"></TextBox>
              </div>
            </td>
          </tr>
          <!-- 利用プラン　-->
          <tr v-if="isSupple">
            <th class="v-middle"><span>利用プラン<em class="label-required">必須</em></span></th>
              <td>
                <p class="l-text" style="padding-left: 20px;">提携サービスをご利用中の方は、割引料金でご利用いただけます。</p>
                <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.form.usagePlanId.$error" validation="required" />
                <div class="l-radio-generalGroup">
                  <div class="l-radio-block">
                    <label class="l-radio">
                      <input type="radio" name="form.usagePlanId" v-model="$v.form.$model.usagePlanId" value = 0> {{this.usagePlanList[0].label}}
                    </label>
                  </div>
                </div>
                <div class="l-radio-officeGroup">
                  <p class="l-radio-officeGroup__title">オフィスステーションをご利用の方向けプラン</p>
                  <div class="l-radio-block">
                    <label class="l-radio">
                      <input type="radio" name="form.usagePlanId" v-model="$v.form.$model.usagePlanId" value = 1> {{this.usagePlanList[1].label}}
                    </label>
                  </div>
                  <div class="l-radio-block">
                    <label class="l-radio">
                      <input type="radio" name="form.usagePlanId" v-model="$v.form.$model.usagePlanId" value = 2> {{this.usagePlanList[2].label}}
                    </label>
                  </div>
                </div>
              </td>
          </tr>

          <!-- 利用プラン　-->
<!--          <tr v-if="isSupple">
            <th class="v-middle"><span>利用プラン<em class="label-required">必須</em></span></th>
            <td class="v-middle">
                <RadioButton v-model="$v.form.$model.usagePlanId2"
                  name="form.usagePlanId"
                  :options="usagePlanList"
                  :selectedValue="form.usagePlanId"
                  style="display: inline-block;"
                ></RadioButton>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.form.usagePlanId.$error" validation="required" />
            </td>
          </tr>
-->
          <tr>
            <th class="v-middle"><span>お問い合わせ・ご質問等</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextArea v-model="$v.form.$model.comment" class="l-formGroup__textArea" />
              </div>
            </td>
          </tr>
        </table>
        <div class="l-scrollBox">
          <p class="l-text">株式会社全国労務診断協会（以下「当社」という）はお客様から以下の情報をご提供いただいております。</p>
          <ul class="l-list is-small">
            <li>会社名、氏名、住所、メールアドレス、電話番号<br>
              サービス申込時に申込書に御記入いただくことで、当社が収集しております。 また、当社は、お客様からご提供いただく情報を以下の目的の範囲内において、当社が提供する労務監査クラウド「
              <template v-if="!isSupple">ヨクスル</template>
              <template v-else>労務サプリ</template>
              」サービスに利用します。お客様の同意なく、情報の収集、目的外の利用を行うことはありません。 </li>
            <li>本サービスの提供や機能拡張に向けた研究開発のため</li>
            <li>本サービスの利用に伴う連絡・メールマガジン・DM・セミナー・各種お知らせ等の配信・送付のため</li>
            <li>本サービスの改善・新規サービスの開発およびマーケティングのため </li>
            <li>キャンペーン・アンケート・モニター・取材等の実施のため </li>
            <li>本サービスに関するご意見、お問い合わせ内容の確認・回答のため</li>
            <li>お客さまの承諾・本申込みに基づく、本サービス開発企業等への個人情報の提供のため </li>
          </ul>
        </div>
        <div class="l-contentsBox__bottom" style="text-align: center;">
          <div class="btn-basic is-inlne is-primary js-savebtn" @click="confirm()"><a>確認して送信する</a></div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import SelectBox from '@/components/parts/form/SelectBox.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
//import RadioButton from '@/components/parts/form/RadioButton.vue';
import constant from '@/const';
import { required, email, maxLength, numeric, requiredIf } from 'vuelidate/lib/validators';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';

export default {
  components: {
    Loading,
    TextBox,
    TextArea,
    SelectBox,
//    RadioButton,
    ValidationErrorMessage,
  },
  data()  {
    return {
      isProcessing: false,
      form: {
        contactType: 1,
        corpName: '',
        responsibleName: '',
        mailAddress: '',
        tel: '',
        comment: '',
        deptName: '',
        responsibleTel: '',
        postCd: '',
        prefectureCd: '1',
        address2: '',
        address3: '',
        faxNo: '',
        introducerHonorificsName: '',
        tmpStr: null,
        entryPlanId: '',
        usagePlanId: '',
      },
      contactTypeList: constant.CONTACT_TYPE,
      prefs: constant.PREFS,
      usagePlanList: [
        {
          value: null,
          label: '',
        }
      ],
    }
  },
  validations: {
    form: {
      contactType: {  },
      corpName: { required },
      responsibleName: { required },
      mailAddress: { required, email },
      tel: { required, maxLength: maxLength(13) },
      comment: { },
      deptName: { },
      responsibleTel: { maxLength: maxLength(13) },
      postCd: { required, maxLength: maxLength(7), numeric },
      prefectureCd: { required },
      address2: { required, maxLength: maxLength(20) },
      address3: { maxLength: maxLength(300) },
      faxNo: { maxLength: maxLength(13) },
      introducerHonorificsName: { },
      usagePlanId: { 
        required: requiredIf(function (value) {
          return this.isSupple && value;
        })
      },
    }
  },
  computed: {
    isSupple() {
      return Object.keys(this.$route.query).includes('supple');
    },
  },
  created: async function() {
    this.form = await this.$store.getters['contactForm/getForm'];
    await this.getUsagePlanList();
  },
  methods: {
    async getUsagePlanList() {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/contact/contact_form/getUsagePlanList');
      if (res) {
        let usagePlanList = [];
        res.data.usagePlanList.forEach(u => {
          usagePlanList.push({
            value: u.usagePlanId,
            label: u.name + " 登録可能件数：" + u.maxCount + "件（¥"+u.amount.toLocaleString()+"/月）",
          });
        });
        this.usagePlanList = usagePlanList;
      }
      this.isProcessing = false;
    },
    async confirm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        this.form.tmpStr = Math.random().toString(32).substring(2);

        if(this.isSupple){
          this.form.entryPlanId=4; //労務サプリ
        }else{
          this.form.entryPlanId=2; //社労士
        }
        await this.$store.dispatch('contactForm/setForm', this.form);
        await this.$store.dispatch('contactForm/setIsSupple', this.isSupple);
        this.$router.push({ name: 'contact-form-confirm' });
      }
      this.isProcessing = false;
    }
  }
}
</script>
